import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { FormControl, FormGroup } from '@angular/forms';
import { Iceutility } from '../../services/iceutility';
import { IcecontrolSettings, IcepanelSettings, IcecontrolPermission } from '../../components/models/icesettings';
import { userTypes } from '../../login/login.config';

@Component({
  selector: 'icetextarea',
  templateUrl: './icetextarea.component.html',
  styleUrls: ['./icetextarea.component.scss']
})
export class IcetextareaComponent implements OnInit {
  // Input Members
  @Input() placeholder: string = "";
  @Input() id: string = "";
  @Input() properties: any = {};
  @Input() ctrl: IcecontrolSettings = null;
  @ViewChild('autosize') autosize: CdkTextareaAutosize;

  // Data Members
  iceFormControl: FormControl = null;
  permission: IcecontrolPermission = null;

  constructor() { }

  ngOnInit() {
    try {
      this.permission = this.ctrl.permissions ? this.ctrl.permissions : new IcecontrolPermission(userTypes.USER_FEATURES.ufNone, userTypes.USER_FEATURE_ACCESS.ufaNone);
      this.iceFormControl = this.ctrl.getFormControl();

      if (this.iceFormControl == null) {
        this.iceFormControl = new FormControl(''); // No control so we create a placeholder control to prevent an errors
      }
      if (this.permission.default_access === userTypes.USER_FEATURE_ACCESS.ufaReadOnly) {
        this.iceFormControl.disable();
      }
    }
    catch (e) {
      console.log(e);
    }
  }

  getValue(): string | number {
    return this.iceFormControl.value;
  }
}
